const PushActionErrorLabel = Object.freeze({
  auth: 'PushAction_Error_GcmAuth',
  gcm: 'PushAction_Error_GcmRetryLimit',
  expiredCertificate: 'PushAction_Error_ExpiredCertificate'
})

export { PushActionErrorLabel }



// WEBPACK FOOTER //
// ./src/common/enum/PushActionErrorEnum.js